export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/identity.js
// module id = 8u1c
// module chunks = 0